import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BoltIcon from '@mui/icons-material/Bolt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupsIcon from '@mui/icons-material/Groups';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SavingsIcon from '@mui/icons-material/Savings';
import StarIcon from '@mui/icons-material/Star';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import VerifiedIcon from '@mui/icons-material/Verified';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const TaxZeronevsTax1099 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [removelistener, setRemovelistener] = useState(true);
  const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  const images = [
    '/assets/images/2290-steps-img.webp',
    '/assets/images/easy-steps-img.webp',
    '/assets/images/941-steps-img.webp',
    // Add more image URLs as needed
  ];
  const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  const handleScroll = (event: any) => {
    const delta = event.deltaY;
    if (delta > 0) {
      // Scroll down, show the next imag
      if (currentImageIndex < 2) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else if (delta < 0) {
      // Scroll up, show the previous image
      if (currentImageIndex > 0) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else {
      setRemovelistener(false);
    }
  };
  function useHorizontalScroll() {
    useEffect(() => {
      const el = Ref.current;
      setTempReturn(tempReturn);
      if (el) {
        const onWheel = (e: any) => {
          if (e.deltaY === 0) return;
          e.preventDefault();
          el.scrollTo({
            behavior: 'smooth',
            top: 0,
            left: 0,
          });
        };

        el.addEventListener('wheel', onWheel);
        if (removelistener === false) {
          el.addEventListener('wheel', onWheel);
        } else if (removelistener === true) {
          el.removeEventListener('wheel', onWheel);
        } else {
          el.addEventListener('wheel', onWheel);
        }
        return () => {
          el.removeEventListener('wheel', onWheel);
        };
      }
      return () => setTempReturn(false);
    }, [removelistener]);
    return Ref;
  }

  const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="TaxZerone vs Tax1099: Which Software is Better in 2026?"
          description="Switch from Tax1099 to TaxZerone and save 20%. TaxZerone delivers superior efficiency with bulk filing, automated error checks, and scalable solutions."
          keywords=""
          canonical="comparison/taxzerone-vs-tax1099/"
          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 0,
          pb: 0,
          position: 'relative',
          background: `
  linear-gradient(
    90deg,
    #040814 0%,
    #061D2A 20%,
    #062420 45%,
    #071A1E 75%,
    #010405 100%
  )
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Typography
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: { xs: 120, md: 260 },
            fontWeight: 900,
            color: 'rgba(177, 177, 177, 0.03)',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        >
          TaxZerone
        </Typography>
        {/* <Container
          sx={{
            position: 'relative',
            mt: 4,
            mb: 0,
          }}
          maxWidth="lg"
        >
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '12px',
              px: 2,
              py: 1.2,
              background:
                'linear-gradient(135deg, rgba(37, 100, 235, 0.51), rgba(104, 104, 104, 0.22))',
              backdropFilter: 'blur(14px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 8px 20px rgba(37,99,235,0.2)',
              color: '#fff',
            }}
          >
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ position: 'relative', zIndex: 2 }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  fontWeight: 400,
                  textAlign: 'center',
                  lineHeight: 1.4,
                }}
              >
                Switching from Tax1099? Get
                <Box
                  component="span"
                  sx={{
                    mx: 0.8,
                    px: 1,
                    py: 0.2,
                    borderRadius: '999px',
                    bgcolor: '#FFD54F',
                    color: '#111',
                    fontWeight: 800,
                    fontSize: '0.95rem',
                  }}
                >
                  20% OFF
                </Box>
                <Box component="span" sx={{ fontWeight: 700 }}>
                  {' '}
                  🚀 your first year with TaxZerone
                </Box>
              </Typography>
            </Stack>
          </Box>
        </Container> */}
        <Container maxWidth="xl" sx={{ mt: { sm: 3, md: 2 } }}>
          <Stack
            direction={{ xs: 'column', md: 'column' }}
            spacing={3}
            sx={{ px: { xs: 2, md: 0 } }}
          >
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'center' },
                alignItems: 'center',
                display: 'flex',
                width: '100%',

                // maxWidth: { xs: 'inherit', lg: 770 },
                // minWidth: { xs: 'inherit', md: 530 },
                pl: { xs: 0, md: 6, lg: 8, xl: 12 },
                justifyContent: 'center',
              }}
            >
              <Box
                component="div"
                sx={{
                  mt: { xs: 2, sm: 4, md: 5 },
                  mb: { xs: 2, sm: 4, md: 5 },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <picture style={{ marginBottom: -7 }}>
                    <source
                      srcSet="/assets/images/taxzerone-vs-tax1099-img.png"
                      className="img-responsive-banner"
                      width={600}
                      height={200}
                    />
                    <source
                      srcSet="/assets/images/taxzerone-vs-tax1099-img.png"
                      className="img-responsive-banner"
                      width={600}
                      height={200}
                    />
                    <img
                      src="/assets/images/taxzerone-vs-tax1099-img.png"
                      alt="E-file IRS Form 940 for the 2025 tax year"
                      className="img-responsive-banner"
                      width={600}
                      height={200}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    color: '#ffffff',
                    mb: 3,
                    lineHeight: 1.2,
                  }}
                >
                  Discover the Ultimate <br />
                  <span style={{ color: '#ffe922' }}>W-2 &amp; 1099</span>{' '}
                  Filing Solution for Your Business
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    mb: 3,
                    color: '#c5c5c5',
                    lineHeight: 1.7,
                  }}
                >
                  From bulk uploads and TIN verification to electronic delivery,
                  printing, mailing, and more, TaxZerone makes <br />
                  filing W-2s, 1099s, and other returns simple and accurate for
                  businesses of all sizes.
                </Typography>

                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 2, md: 5 }}
                  justifyContent={{
                    xs: 'center',
                    md: 'center',
                  }}
                  alignItems="center"
                  sx={{ mt: 4 }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mr: { xs: 0, md: 4 },
                    }}
                  >
                    <Button
                      variant="contained"
                      className="btn-primary"
                      sx={{
                        mt: 2,
                        transition: 'all 0.3s ease',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.05)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-tax1099`}
                    >
                      Switch to TaxZerone Today
                    </Button>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1.5,
                        fontSize: {
                          xs: 13,
                          sm: 14,
                        },
                        color: '#6B7280',
                        fontWeight: 500,
                      }}
                    >
                      Most Business’s Best Choices
                    </Typography>
                  </Box>

                  {/* <Hidden mdDown>
                    <Box>
                      <picture>
                        <source
                          srcSet="/assets/images/irs-authorized.webp"
                          width={70}
                          height={69}
                        />
                        <source
                          srcSet="/assets/images/irs-authorized.png"
                          width={70}
                          height={69}
                        />
                        <img
                          src="/assets/images/irs-authorized.png"
                          loading="lazy"
                          alt="IRS Authorized e-file Provider"
                          width={70}
                          height={69}
                        />
                      </picture>
                    </Box>
                  </Hidden> */}
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone vs Tax1099: Stop risking delays and rejections.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Upgrade to <span style={{ fontWeight: 600 }}>TaxZerone</span>{' '}
                for faster filing, real-time TIN matching, seamless
                integrations, and smarter compliance.
              </Typography>
            </Grid>
            <TableContainer
              sx={{
                border: '1px solid #e2e8f0',
                overflowX: {
                  xs: 'auto',
                  md: 'unset',
                },
                background: '#ffffff',
                boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                mx: 'auto',
                width: '100%',
                borderRadius: '12px',
                overflow: 'hidden',
                mb: 4,
              }}
            >
              <Box sx={{ minWidth: '840px' }}>
                <Table
                  sx={{
                    minWidth: 700,
                    borderCollapse: 'collapse',
                    width: '100%',

                    '& thead': {
                      background: '#0f172a',
                    },

                    '& thead th': {
                      fontSize: {
                        xs: '11px',
                        sm: '12px',
                        md: '13px',
                      },
                      fontWeight: 600,
                      textAlign: 'left',
                      // color: '#e2e8f0',
                      padding: {
                        xs: '10px 8px',
                        sm: '14px 16px',
                        md: '16px 20px',
                      },
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap',
                    },

                    '& tbody tr': {
                      transition: 'background-color 0.15s ease',
                    },

                    '& tbody tr:nth-of-type(even)': {
                      backgroundColor: '#f8fafc',
                    },

                    // '& tbody tr:hover': {
                    //   backgroundColor: '#c4c4c4',

                    //   '& td': {
                    //     color: '#fff',
                    //   },
                    // },

                    '& tbody td': {
                      fontSize: {
                        xs: '12px',
                        sm: '13.5px',
                        md: '14.5px',
                      },
                      fontWeight: 400,
                      textAlign: 'left',
                      padding: {
                        xs: '10px 8px',
                        sm: '13px 16px',
                        md: '13px 20px',
                      },
                      color: '#1e293b',
                      borderBottom: '1px solid #e4eaf0',
                      transition: 'color 0.15s ease',
                    },

                    '& tbody td:first-of-type': {
                      whiteSpace: 'nowrap',
                      fontWeight: 600,
                      color: '#0f172a',
                    },

                    // '& tbody tr:hover td:first-of-type': {
                    //   color: '#fff',
                    // },

                    '& tbody tr:last-of-type td': {
                      borderBottom: 'none',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          background:
                            'linear-gradient(135deg, rgb(29, 29, 29) 0%, rgb(99, 99, 99) 100%)',
                          color: '#ffffff',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            fontWeight: 700,
                          }}
                        >
                          Feature
                        </Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          background:
                            'linear-gradient(135deg, #f0f0f0 0%, rgb(234, 234, 238) 100%)',
                          textAlign: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 1,
                            width: '100%',
                          }}
                        >
                          <Box
                            component="img"
                            src="/assets/images/logo.png"
                            alt="TaxZerone"
                            sx={{
                              height: { xs: '20px', sm: '24px', md: '32px' },
                              width: 'auto',
                            }}
                          />

                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 700,

                              whiteSpace: 'nowrap',
                            }}
                          >
                            (Recommended)
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          background:
                            'linear-gradient(135deg, #f0f0f0 0%, rgb(234, 234, 238) 100%)',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <Box
                            component="img"
                            src="/assets/images/tax1099-logo.png"
                            alt="Tax1099"
                            sx={{
                              height: { xs: '20px', sm: '24px', md: '28px' },
                              width: 'auto',
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    <TableRow>
                      <TableCell>IRS Authorization</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        ✓ Yes
                      </TableCell>
                      <TableCell>✓ Yes</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Platform Positioning</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          All-in-one tax filing platform
                        </span>{' '}
                        for businesses, accountants, and service providers
                      </TableCell>
                      <TableCell>
                        Primarily focused on select information returns
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Setup Complexity</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          Simple form entry
                        </span>{' '}
                        — ready in minutes{' '}
                        <Box
                          component="span"
                          sx={{
                            display: 'inline-block',
                            ml: 1,
                            px: 1,
                            py: 0.2,
                            bgcolor: '#16a34a',
                            color: '#fff',
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                          }}
                        >
                          EASIER
                        </Box>
                      </TableCell>
                      <TableCell>Complex integrations required</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Electronic Delivery</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        IRS-compliant eDelivery{' '}
                        <Box
                          component="span"
                          sx={{
                            display: 'inline-block',
                            ml: 1,
                            px: 1,
                            py: 0.2,
                            bgcolor: '#16a34a',
                            color: '#fff',
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                          }}
                        >
                          Better
                        </Box>
                      </TableCell>
                      <TableCell>Standard eDelivery</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Print & Mail Price</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>$1.75/form</span> —
                        cost-effective{' '}
                        <Box
                          component="span"
                          sx={{
                            display: 'inline-block',
                            ml: 1,
                            px: 1,
                            py: 0.2,
                            bgcolor: '#16a34a',
                            color: '#fff',
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                          }}
                        >
                          BEST
                        </Box>
                      </TableCell>
                      <TableCell>
                        $1.90/form — slightly higher and less flexible
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Form Coverage</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>60+ forms</span>{' '}
                        including W-2, all 1099 variants, 1098, 1097, ACA
                        (1094/1095), 94X series, 940, 943, 944, 945, 1042-S,
                        1120-S, 1065, 5498, state filings, and more
                      </TableCell>
                      <TableCell>
                        1099s, W-2s, ACA (1095-C/1094-C), 1098, 94X, 1042-S,
                        5498, and more
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>User Experience</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          Ultra-Modern, intuitive UI
                        </span>{' '}
                        — fast filings with minimal clicks
                      </TableCell>
                      <TableCell>
                        Standard interface with step-by-step form entry
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Integration & Import Options</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        QuickBooks Online, Xero, Excel/CSV, EFW2, FIRE-Formatted
                        (P1220) files
                      </TableCell>
                      <TableCell>QuickBooks, Xero, NetSuite, etc.</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Delivery Recipient Statement</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          ZeroneVault secure portal
                        </span>{' '}
                        for easy recipient access
                      </TableCell>
                      <TableCell>
                        Limited or no secure portal available
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Learning Curve</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        File in just 5 minutes
                      </TableCell>
                      <TableCell>Takes more than 5 minutes</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Pricing Model</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        Simple per-form pricing — fully transparent
                      </TableCell>
                      <TableCell>Tiered & subscription plans</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Security</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          RSA-2048 encryption
                        </span>
                        , secure data handling, industry-standard protections{' '}
                        <span style={{ fontSize: 12 }}>
                          [Supports all modern devices and browsers]{' '}
                        </span>
                      </TableCell>
                      <TableCell>
                        256-bit encryption, fewer advanced features
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Compliance Updates</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        Automatic real-time IRS & state updates
                      </TableCell>
                      <TableCell>Periodic updates</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Regulatory Compliance</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        Full IRS & state compliance guaranteed
                      </TableCell>
                      <TableCell>Supports IRS/State compliance</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Platform Type</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        True one-stop tax filing solution
                      </TableCell>
                      <TableCell>Limited form support</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Support Availability</TableCell>
                      <TableCell
                        sx={{ backgroundColor: '#e6f7f0', fontWeight: 600 }}
                      >
                        Phone (English & Spanish), Email & Chat support from Tax
                        Experts
                      </TableCell>
                      <TableCell>Fixed support</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </TableContainer>
            <Grid size={12}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                <span style={{ fontWeight: 600 }}>TaxZerone</span> – Business’s
                Choice for Easy W-2 & 1099 Filing
              </Typography>
              <Box
                component="div"
                sx={{
                  margin: 'auto',
                  textAlign: 'center',
                  mt: 1,
                  mb: { xs: 0, md: 0 },
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary medium"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-tax1099`}
                >
                  Get Started with TaxZerone
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Why TaxZerone Wins?
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="xl"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ px: { xs: 2, md: 3 } }}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              flexWrap={{ xs: 'nowrap', sm: 'wrap', md: 'nowrap' }}
              spacing={4}
              sx={{
                alignItems: 'stretch',
                justifyContent: 'center',
                p: 2,
              }}
            >
              {/* 1. Modern UI with Intelligent Automation */}
              <Box
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 16px)', md: 250 },
                  maxWidth: { xs: '100%', sm: 280, md: 250 },
                  flexShrink: 0,
                  pt: 4,
                  mx: { xs: 'auto', sm: 0 },

                  border: '1px solid transparent',
                  borderRadius: 2,
                  transition: 'border-color 0.2s ease',
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    border: '3px solid transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      borderRadius: 5.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 118,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 2,
                    }}
                  >
                    {/* Background Text */}

                    {/* Icon Circle */}
                    <Box
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#1da94a',
                        position: 'relative',
                        zIndex: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          fontSize: 36,
                          fontWeight: 900,
                          color: 'transparent',
                          WebkitTextStroke: '2px rgba(255, 255, 255, 0.93)',
                          letterSpacing: 2,
                          zIndex: 0,
                          userSelect: 'none',
                        }}
                      >
                        UI
                      </Typography>
                    </Box>
                  </Box>
                  <Card
                    sx={{
                      borderRadius: 5,
                      overflow: 'hidden',
                      boxShadow: '0 5px 10px rgba(0,0,0,0.08)',
                      transition: '0.3s',
                      height: '100%',
                      minHeight: 380,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/ui-with-intelligent-automation.png"
                      alt="Modern UI with Intelligent Automation"
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: 150,
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                      }}
                    />
                    <CardContent
                      sx={{
                        pt: 6,
                        px: 2.5,
                        pb: 2.5,
                        textAlign: 'center',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: '15px', lineHeight: 1.2 }}
                      >
                        Modern UI with Intelligent Automation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.6, fontSize: '13px' }}
                      >
                        A clean and intuitive interface guides you through every
                        step, making tax filing simple even for first-time
                        users.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>

              {/* 2. Easy Filing Flow */}
              <Box
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 16px)', md: 250 },
                  maxWidth: { xs: '100%', sm: 280, md: 250 },
                  flexShrink: 0,
                  pt: 4,
                  mx: { xs: 'auto', sm: 0 },
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    border: '3px solid transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      borderRadius: 5.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#1da94a',
                      position: 'absolute',
                      top: 118,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 2,
                    }}
                  >
                    <AssignmentIcon sx={{ color: '#fff', fontSize: 30 }} />
                  </Box>
                  <Card
                    sx={{
                      borderRadius: 5,
                      overflow: 'hidden',
                      boxShadow: '0 5px 10px rgba(0,0,0,0.08)',
                      transition: '0.3s',
                      height: '100%',
                      minHeight: 380,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/easy-filing-flow.png"
                      alt="Easy Filing Flow"
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: 150,
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                      }}
                    />
                    <CardContent
                      sx={{
                        pt: 6,
                        px: 2.5,
                        pb: 2.5,
                        textAlign: 'center',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: '15px' }}
                      >
                        Easy Filing Flow
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.6, fontSize: '13px' }}
                      >
                        Complete your filing in minutes with a streamlined
                        process, smart validations, and step-by-step guidance
                        that reduces errors.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>

              {/* 3. No Complex Setup */}
              <Box
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 16px)', md: 250 },
                  maxWidth: { xs: '100%', sm: 280, md: 250 },
                  flexShrink: 0,
                  pt: 4,
                  mx: { xs: 'auto', sm: 0 },
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    border: '3px solid transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      borderRadius: 5.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#1da94a',
                      position: 'absolute',
                      top: 118,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 2,
                    }}
                  >
                    <BoltIcon sx={{ color: '#fff', fontSize: 30 }} />
                  </Box>
                  <Card
                    sx={{
                      borderRadius: 5,
                      overflow: 'hidden',
                      boxShadow: '0 5px 10px rgba(0,0,0,0.08)',
                      transition: '0.3s',
                      height: '100%',
                      minHeight: 380,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/no-complex-setup.png"
                      alt="No Complex Setup"
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: 150,
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                      }}
                    />
                    <CardContent
                      sx={{
                        pt: 6,
                        px: 2.5,
                        pb: 2.5,
                        textAlign: 'center',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: '15px' }}
                      >
                        No Complex Setup
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.6, fontSize: '13px' }}
                      >
                        Get started instantly with no integrations, software
                        installs, or technical configuration required — just
                        provide your data and file in minutes.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>

              {/* 4. Built for Real Businesses */}
              <Box
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 16px)', md: 260 },
                  maxWidth: { xs: '100%', sm: 280, md: 260 },
                  flexShrink: 0,
                  pt: 4,
                  mx: { xs: 'auto', sm: 0 },
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    border: '3px solid transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      borderRadius: 5.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#1da94a',
                      position: 'absolute',
                      top: 118,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 2,
                    }}
                  >
                    <ApartmentIcon sx={{ color: '#fff', fontSize: 30 }} />
                  </Box>
                  <Card
                    sx={{
                      borderRadius: 5,
                      overflow: 'hidden',
                      boxShadow: '0 5px 10px rgba(0,0,0,0.08)',
                      transition: '0.3s',
                      height: '100%',
                      minHeight: 380,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/built-for-real-businesses.png"
                      alt="Built for Real Businesses"
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: 150,
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                      }}
                    />
                    <CardContent
                      sx={{
                        pt: 6,
                        px: 2.5,
                        pb: 2.5,
                        textAlign: 'center',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: '15px' }}
                      >
                        Built for Real Businesses
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.6, fontSize: '13px' }}
                      >
                        Designed for small and medium businesses, growing
                        companies, large organizations, and tax professionals —
                        TaxZerone delivers flexible workflows that scale with
                        your filing needs.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>

              {/* 5. Transparent Pricing */}
              <Box
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 16px)', md: 260 },
                  maxWidth: { xs: '100%', sm: 280, md: 260 },
                  flexShrink: 0,
                  pt: 4,
                  mx: { xs: 'auto', sm: 0 },
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    height: '100%',
                    border: '3px solid transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      borderRadius: 5.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#1da94a',
                      position: 'absolute',
                      top: 118,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 2,
                    }}
                  >
                    <PriceCheckIcon sx={{ color: '#fff', fontSize: 30 }} />
                  </Box>
                  <Card
                    sx={{
                      borderRadius: 5,
                      overflow: 'hidden',
                      boxShadow: '0 5px 10px rgba(0,0,0,0.08)',
                      transition: '0.3s',
                      height: '100%',
                      minHeight: 380,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/transparent-pricing.png"
                      alt="Transparent Pricing"
                      loading="lazy"
                      sx={{
                        width: '100%',
                        height: 150,
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                      }}
                    />
                    <CardContent
                      sx={{
                        pt: 6,
                        px: 2.5,
                        pb: 2.5,
                        textAlign: 'center',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: '15px' }}
                      >
                        Transparent Pricing
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.6, fontSize: '13px' }}
                      >
                        TaxZerone shows your exact costs upfront. You know what
                        you'll pay before filing — no hidden charges, no
                        surprise fees. Just clear rates and honest billing.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Businesses Are Switching from Tax1099 to TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                (6 Smart Reasons to Make the Switch Today)
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            {/* Card 1 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <SavingsIcon sx={{ fontSize: 40, color: '#8492c0' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Save Money Immediately
                </Typography>
                <Typography variant="body1">
                  Enjoy lower per-form pricing with no setup fees, no monthly
                  subscriptions, and no hidden charges.{' '}
                  <span style={{ fontWeight: 600 }}>
                    You only pay for what you file
                  </span>{' '}
                  - nothing more.
                </Typography>
              </Paper>
            </Grid>

            {/* Card 2 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <AccessTimeIcon sx={{ fontSize: 40, color: '#76ce97' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File in Minutes, Not Hours
                </Typography>
                <Typography variant="body1">
                  Upload your data or enter manually —{' '}
                  <span style={{ fontWeight: 600 }}>
                    complete your filing in under 5 minutes
                  </span>
                  . No technical expertise is required.
                </Typography>
              </Paper>
            </Grid>

            {/* Card 3 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <MarkEmailReadIcon sx={{ fontSize: 40, color: '#8492c0' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy Recipient Copy Delivery
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>ZeroneVault</span> — our
                  secure portal for easy recipient access. Recipients get their
                  forms instantly with no printing, stuffing envelopes, or
                  postage costs.
                </Typography>
              </Paper>
            </Grid>

            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>

            {/* Card 4 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <VerifiedIcon sx={{ fontSize: 40, color: '#76ce97' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Full Compliance Guaranteed
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>One-stop platform</span> for
                  all tax forms (1099s, W-2s, ACA & more) with automatic IRS and
                  state compliance updates.
                </Typography>
              </Paper>
            </Grid>

            {/* Card 5 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <GroupsIcon sx={{ fontSize: 40, color: '#8492c0' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Join a Growing Community
                </Typography>
                <Typography variant="body1">
                  65,000+ businesses have already chosen{' '}
                  <span style={{ fontWeight: 600 }}>TaxZerone</span>. We're
                  growing fast because we put customers first.
                </Typography>
              </Paper>
            </Grid>

            {/* Card 6 */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <SupportAgentIcon sx={{ fontSize: 40, color: '#76ce97' }} />
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Get Help When You Need It
                </Typography>
                <Typography variant="body1">
                  With real{' '}
                  <span style={{ fontWeight: 600 }}>24/7 support</span>, you're
                  never stuck. Tax deadline at midnight? We've got you covered.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center', // Centers horizontally
                  alignItems: 'center',
                  width: '100%',
                  mb: { md: 2, sm: 0, xs: 2 },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.2,
                    px: 2.5,
                    py: 1,
                    borderRadius: '999px',
                    backgroundColor: '#ffffff',
                    border: '1px solid #D6E0FF',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#3D49B7',
                      fontWeight: 600,
                      fontSize: {
                        lg: 12,
                        md: 12,
                        sm: 10,
                        xs: 10,
                      },
                      letterSpacing: 0.6,
                    }}
                  >
                    PRICING COMPARISON
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                See How Much You'll Save
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Real pricing, real savings. No tricks, no fine print.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={4}
            sx={{
              m: 2,
              mt: 2,
              pb: { xs: 0, sm: 4, md: 7 },
              justifyContent: 'center',
              alignItems: 'stretch',
            }}
          >
            {/* TaxZerone - Featured / Highlighted Pricing Card */}
            <Grid size={{ xs: 12, sm: 10, md: 5 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: '24px',
                  minHeight: '100%',
                  background:
                    'linear-gradient(135deg, rgb(7, 30, 75), rgba(0, 0, 0, 0.93))',
                  color: '#ffffff',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  boxShadow: '0 20px 40px rgba(118, 206, 151, 0.15)',
                  //  border: '2px solid #76ce97',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '-20%',
                    right: '-20%',
                    width: '60%',
                    height: '60%',
                    background:
                      'radial-gradient(circle, rgba(118, 206, 152, 0.12) 0%, rgba(0,0,0,0) 70%)',
                    pointerEvents: 'none',
                  }}
                />

                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 4,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 28, md: 26, sm: 24, xs: 24 },
                        fontWeight: 800,
                        letterSpacing: '-0.5px',
                        color: '#ffffff',
                      }}
                    >
                      TaxZerone
                    </Typography>
                    <Chip
                      icon={
                        <StarIcon
                          sx={{ color: '#111827 !important', fontSize: '14px' }}
                        />
                      }
                      label="BEST VALUE"
                      sx={{
                        backgroundColor: '#76ce97',
                        color: '#111827',
                        fontWeight: 800,
                        fontSize: '11px',
                        letterSpacing: '0.5px',
                        height: '28px',
                        borderRadius: '20px',
                        px: 0.5,
                      }}
                    />
                  </Box>

                  {/* Highlighted Pricing Section */}
                  <Box
                    sx={{
                      mb: 4,
                      p: 3,
                      borderRadius: '16px',
                      backgroundColor: 'rgba(118, 206, 151, 0.08)',
                      border: '1px dashed rgba(118, 206, 151, 0.3)',
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#76ce97',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        fontSize: '12px',
                        mb: 1,
                      }}
                    >
                      Starts At Just
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'baseline',
                        flexWrap: 'wrap',
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: { lg: 44, md: 40, sm: 36, xs: 32 },
                          fontWeight: 900,
                          color: '#ffffff',
                          lineHeight: 1,
                        }}
                      >
                        $2.49
                      </Typography>
                    </Box>

                    <Divider
                      sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }}
                    />

                    <Box
                      sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#76ce97',
                          fontWeight: 700,
                          fontSize: '16px',
                        }}
                      >
                        As low as $0.59
                        <Box
                          component="span"
                          sx={{
                            color: '#9ca3af',
                            fontWeight: 400,
                            fontSize: '14px',
                          }}
                        >
                          {' '}
                          /form for bulk filings
                        </Box>
                      </Typography>
                    </Box>
                  </Box>

                  {/* Features List */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      mb: 4,
                      px: 1,
                    }}
                  >
                    {[
                      'No setup fees',
                      'No monthly charges',
                      'Bulk discounts',
                      'Expert support (Phone, Live chat & Email)',
                      'All features included',
                    ].map((text, index) => (
                      <Box
                        key={index}
                        sx={{ display: 'flex', alignItems: 'flex-start' }}
                      >
                        <CheckCircleIcon
                          sx={{
                            color: '#76ce97',
                            mr: 2,
                            mt: '2px',
                            fontSize: '18px',
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{ color: '#e5e7eb', fontWeight: 500 }}
                        >
                          {text}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                <Button
                  variant="contained"
                  className="btn-secondary medium"
                  href="/pricing/"
                >
                  Start Saving Now
                </Button>
              </Paper>
            </Grid>

            {/* Tax1099 - Competitor Card (Subdued Clean Aesthetic) */}
            <Grid size={{ xs: 12, sm: 10, md: 5 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: '24px',
                  minHeight: '100%',
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 4,
                      height: '28px',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 24, md: 22, sm: 20, xs: 20 },
                        fontWeight: 700,
                        color: '#4b5563',
                      }}
                    >
                      Tax1099
                    </Typography>
                  </Box>

                  {/* Subdued Competitor Pricing Layout */}
                  <Box
                    sx={{
                      mb: 4,
                      p: 3,
                      borderRadius: '16px',
                      backgroundColor: '#f9fafb',
                      border: '1px solid #f3f4f6',
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#9ca3af',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        fontSize: '11px',
                        mb: 1,
                      }}
                    >
                      Standard Cost
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        fontSize: { lg: 32, md: 30, sm: 26, xs: 24 },
                        fontWeight: 700,
                        color: '#374151',
                      }}
                    >
                      Starts at $2.99
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#6b7280',
                        mt: 0.5,
                        fontWeight: 500,
                      }}
                    >
                      per form
                    </Typography>

                    <Divider sx={{ my: 2, borderColor: '#e5e7eb' }} />

                    <Typography
                      variant="body2"
                      sx={{
                        color: '#dc2626',
                        fontWeight: 600,
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                      }}
                    >
                      + $1.90 per print & mail
                    </Typography>
                  </Box>

                  {/* Competitor Limits List */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      mb: 4,
                      px: 1,
                    }}
                  >
                    {[
                      'Tiered pricing plans',
                      'Essential, Teams & Scale Subscription',
                      'Volume requirements',
                      'Integration fees',
                      'Limited support hours',
                      'Add-on costs',
                    ].map((text, index) => (
                      <Box
                        key={index}
                        sx={{ display: 'flex', alignItems: 'flex-start' }}
                      >
                        <RemoveCircleOutlineIcon
                          sx={{
                            color: '#d1d5db',
                            mr: 2,
                            mt: '2px',
                            fontSize: '18px',
                          }}
                        />
                        <Typography variant="body1" sx={{ color: '#6b7280' }}>
                          {text}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1.2,
                  px: 2.5,
                  py: 1,
                  mb: 3,
                  borderRadius: '999px',
                  backgroundColor: '#ffffff',
                  border: '1px solid #D6E0FF',
                }}
              >
                <Typography
                  sx={{
                    color: '#3D49B7',
                    fontWeight: 600,
                    fontSize: {
                      lg: 12,
                      md: 12,
                      sm: 10,
                      xs: 10,
                    },
                    letterSpacing: 0.6,
                  }}
                >
                  REAL STORIES
                </Typography>
              </Box>
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 3 },
                }}
              >
                Hear What Our Clients Say About Us
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{ fontSize: { md: 22, sm: 20, xs: 18 } }}
              >
                TaxZerone Made Filing So Much Easier!
              </Typography> */}

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                {/* Card 1 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        The site was simple to use.{' '}
                        <span style={{ fontWeight: 600 }}>
                          I will definitely continue using
                        </span>{' '}
                        TaxZerone and let others know as well.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: { xs: 2, sm: 5 }, mb: 0 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      Bruce Williams
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        textAlign: 'right',
                        color: '#6b6b6b',
                      }}
                    >
                      Accounting Manager
                    </Typography>
                  </Paper>
                </Grid>

                {/* Card 2 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I have tried 5 other companies listed by the IRS, and
                        yours is the only one that would support what I needed.{' '}
                        <span style={{ fontWeight: 600 }}>
                          And it is laid out very well.
                        </span>{' '}
                        Well done.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      Charles F Marino
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        textAlign: 'right',
                        color: '#6b6b6b',
                      }}
                    >
                      Managing Member, LLC
                    </Typography>
                  </Paper>
                </Grid>

                {/* Card 3 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        This website with its forms were{' '}
                        <span style={{ fontWeight: 600 }}>more of a match</span>{' '}
                        than the other site I tried. I&apos;m very happy with my
                        experience.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: { md: 8, sm: 8, xs: 2 }, mb: 0 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      Susan Matthews
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        textAlign: 'right',
                        color: '#6b6b6b',
                      }}
                    >
                      Accounting Director
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to Make the Switch?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Join <span style={{ color: '#ffe922' }}>65,000+ businesses</span> who
          choose simplicity, savings, and superior support with TaxZerone.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-tax1099`}
          >
            Switch to TaxZerone Today
          </Button>
          {/* <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              color: '#f3f3f3',
              mt: 2,
              lineHeight: 1.5,
            }}
          >
            <b>Special offer:</b>{' '}
            <span style={{ color: '#ffe922' }}>20% off</span> for Tax1099
            switchers
          </Typography> */}
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        sx={{ mb: 0 }}
        component="section"
        aria-labelledby="comparison-tax1099-faq"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5, md: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            mt={{ xs: 2, sm: 5 }}
            mb={2}
          >
            <Typography
              variant="h2"
              id="comparison-tax1099-faq"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 0 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              {/* Question 1 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Why choose TaxZerone over Tax1099?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 2 }}>
                      Small and mid-sized businesses prefer{' '}
                      <span style={{ fontWeight: 600 }}>
                        TaxZerone over Tax1099
                      </span>{' '}
                      - because Tax1099 primarily focuses on information returns
                      and complex UI integrations.
                    </Typography>
                    <Typography
                      component="div"
                      sx={{ mt: 1, mb: 2, fontWeight: 600 }}
                    >
                      TaxZerone offers:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.3 } }}>
                      <li>
                        A user-friendly platform with on-screen prompts for each
                        field.
                      </li>
                      <li>
                        Supports a wider range of IRS forms (1099 series, 1098
                        series, W-2, 94x, 990, 1120-S, 1065, extension forms,
                        state filings, and more)
                      </li>
                      <li>
                        Competitive bulk-form pricing, especially for small and
                        mid-sized businesses
                      </li>
                      <li>
                        Supports bulk upload and high-volume filing capabilities
                      </li>
                      <li>Fast and secure e-delivery and print-mail options</li>
                      <li>
                        Dedicated customer support via phone (English and
                        Spanish), chat, and email.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Question 2 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Why does TaxZerone offer better value than Tax1099?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Box
                      component="ul"
                      sx={{ mt: 1, mb: 0, '& li': { mb: 1.3 } }}
                    >
                      <li>
                        TaxZerone delivers more value at a lower price. You pay
                        less, but you get more.
                      </li>
                      <li>
                        Many additional features like multi-user access, that
                        are treated as add-ons in Tax1099, are included at no
                        extra cost. From bulk upload and workflow flexibility to
                        built-in compliance checks, everything is designed to
                        give you full functionality without hidden fees or
                        surprise upgrades. It&apos;s straightforward pricing
                        with maximum value built in.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Question 3 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can I switch from Tax1099 to TaxZerone?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Yes, you can switch from Tax1099 to TaxZerone at any time.
                      However, migrating historical filings and maintaining
                      continuity may require exporting data from Tax1099 and
                      importing it into TaxZerone. TaxZerone&apos;s support team
                      can assist in the transition process to ensure a smooth
                      switch.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Question 4 */}
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Does TaxZerone offer a wider range of tax forms compared to
                  Tax1099?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Yes. TaxZerone offers an extensive list of IRS forms,
                      including 1099 series, 1098 series, W-2, ACA forms, Form
                      2290, 990 series, business tax forms, extension forms,
                      state filings, and many more. It is more convenient for
                      businesses and tax professionals to file their forms in
                      one place.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Question 5 */}
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Which platform is the better choice for accountants and tax
                  preparers?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Box
                      component="ul"
                      sx={{ mt: 1, mb: 0, '& li': { mb: 1.3 } }}
                    >
                      <li>
                        TaxZerone is designed for tax professionals, including
                        CPAs, EROs, RAs, EAs, 3504 Agents, and other authorized
                        representatives. Each role has its own workflow that is
                        specific to those responsibilities.
                      </li>
                      <li>
                        We also support role-based signatures and authorization
                        rules at the return level, which it uses for managing
                        IRS forms such as Form 2848, Form 8879, and Form 8655.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Question 6 */}
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Does TaxZerone provide assistance throughout the tax filing
                  period?
                </Typography>
                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Yes. TaxZerone offers 24/7 expert support during the tax
                      filing period via live chat and email. Users can get help
                      with form preparation, filing errors, and any other filing
                      issues to ensure a smooth e-filing experience.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default TaxZeronevsTax1099;
